import { combineReducers } from 'redux';

import apiError from './apiError';
import byId from './byId';
import isLoading from './isLoading';

export default combineReducers({
  byId,
  isLoading,
  apiError,
});
